import * as React from "react";
import Select from 'react-select';
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore
} from "react-toasts";
import { callApi } from "../../utils/api";
import isEmpty from 'lodash/isEmpty';

export interface PropertyOwnerItem {
    id?: string;
    name: string;
    mobile: string;
    email: string;
}
type AllProps = {
    refetch: any;
    navigateToDocs: any;
    initialValue: any;
    required: any;
};
export interface BroItem {
    id?: string;
    bro_id?: string;
    designation: string;
    email: string;
    name: string;
    mobile: string;
}

class VettingLoginForm extends React.Component<AllProps> {
    state = {
        ...this.props.initialValue
    };
    componentDidMount() {
        console.log("Did Mount:", this.state);
        
        if (!this.state.privateList || !this.state.privateList.length) {
            this.setState({ privateList: [] });
            this.addProperty();
        }
        if (!this.state.brolist || !this.state.brolist.length) {
            this.setState({ brolist: [] });
            this.addBro();
        }

        const delete_items: any = this.state.delete_items
            ? this.state.delete_items
            : Object.create({});
        if (!delete_items || !delete_items.brolist) {
            delete_items.brolist = [];
        }
        if (!delete_items || !delete_items.privateList) {
            delete_items.privateList = [];
        }
        this.setState({ delete_items });
        this.getBanks();
        this.getLawHandsBranches();
        const isNewFile = Number(this.props.initialValue.file_idfk) === 0;

        if (!isNewFile || this.state.existLoading) {
            this.ifIdBankBranches();
        } else {
            if (isEmpty(this.state.existingFileNo)) {
                this.getBankBranches();
            }
        }
    }
    // componentDidUpdate(prevProps) {
    //     if (this.props.initialValue !== prevProps.initialValue) {
    //         this.setState(prevState => ({
    //             ...prevState,
    //             ...this.props.initialValue
    //         }));
    //     }
    // }    
    ifIdBankBranches() {
        callApi("GET", "bank_branch_get.php")
            .then(res => res.data)
            .then(result => {
                console.log("bank_branch_get2", result.data);
                
                this.setState({ branches: result.data });
                if (this.state.bank_name) {
                    this.ifIdfilterBranches(this.state.bank_name);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    getBanks() {
        callApi("GET", "bank_get.php")
            .then(res => res.data)
            .then(result => {
                this.setState({ banks: result.data });
            })
            .catch(err => {
                console.log(err);
            });
    }
    getBankBranches() {
        callApi("GET", "bank_branch_get.php")
            .then(res => res.data)
            .then(result => {
                this.setState({
                    branches: result.data,
                    filteredBranches: [],
                }, () => {
                    // Callback runs *after* setState is applied
                    if (!isEmpty(this.state.bank_name)) {
                        this.filterBranches(this.state.bank_name);
                    }
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    getLawHandsBranches() {
        callApi("GET", "get_branch.php")
            .then(res => res.data)
            .then(response => {
                this.setState({ lawhandsBranches: response.data });
            })
            .catch(err => {
                console.log(err);
            });
    }
    ifIdfilterBranches = bankid => {
        const filteredBranches = this.state.branches.filter(branch => branch.bank_id === bankid);
        const state = this.state;
        state.filteredBranches = filteredBranches;
        this.setState({ ...state });
    };

    filterBranches = bankid => {
        const filteredBranches = this.state.branches.filter(branch => branch.bank_id === bankid);
        const state = this.state;
        state.filteredBranchesproduct = filteredBranches;
        this.setState({ ...state });
    };

    filterBranchesproduct = (productid) => {
        const state = { ...this.state }; // Create a copy of the state
        const userBranches = state.lawhands_branch.split(","); // Split comma-separated branches into an array

        const filteredBranches = state?.filteredBranchesproduct?.filter((branch) => {
            // Split the branch's lawhands_branch into an array for comparison
            const branchLawhandsArray = branch.lawhands_branch.split(",");
            // Check if any of the branch's lawhands_branch matches userBranches
            const hasMatchingBranch = branchLawhandsArray.some((b) => userBranches.includes(b));

            return (
                branch.product_id === productid &&
                branch.bank_id === state.bank_name &&
                hasMatchingBranch // Check if there's a matching branch
            );
        });

        state.filteredBranches = filteredBranches;

        if (filteredBranches.length === 0) {
            state.branch = "";
        }

        this.setState(state);
    };

    filterProduct = bankid => {
        if (bankid) {
            const filteredProduct = this.state.products.filter(
                branch => branch.bank_id === bankid
            );
            const state = this.state;
            state.filteredProduct = filteredProduct;
            this.setState({ ...state });
        } else {
            this.setState({ product_id: "" });
        }
    };
    getBros = branchid => {
        callApi("POST", "bro_get.php", { branch_idfk: branchid })
            .then(res => res.data)
            .then(response => {
                if (!response.data.length) {
                    this.addBro();
                } else {
                    this.setState({ brolist: response.data });
                    this.handleSubmit();
                }
            });
    };
    addBro = (): void => {
        const brolist: BroItem[] = this.state.brolist ? this.state.brolist : [];
        brolist.push({ name: "", mobile: "", email: "", designation: "" });
        this.setState({ brolist });
    };

    removeBro = (modal: BroItem, index: number): void => {
        const brolist: BroItem[] = this.state.brolist;
        brolist.splice(index, 1);

        const delete_items: any = this.state.delete_items
            ? this.state.delete_items
            : Object.create({});
        if (!delete_items || !delete_items.brolist) {
            delete_items.brolist = [];
        }
        delete_items.brolist.push(modal.id);
        this.setState({ brolist, delete_items });
        this.handleSubmit();
    };

    handleBroChange = (e: any, index: number) => {
        const brolist: BroItem[] = this.state.brolist;
        brolist.forEach((itm: any, i) => {
            if (i === index) {
                itm[e.target.name] = e.target.value;
            }
        });
        this.setState({ brolist });
        this.handleSubmit();
    };

    addProperty = (): void => {
        const privateList: PropertyOwnerItem[] = this.state.privateList
            ? this.state.privateList
            : [];
        privateList.push({ name: "", mobile: "", email: "" });
        this.setState({ privateList });
    };
    removeProperty = (modal: PropertyOwnerItem, index: number): void => {
        const privateList: PropertyOwnerItem[] = this.state.privateList;
        privateList.splice(index, 1);

        const delete_items: any = this.state.delete_items
            ? this.state.delete_items
            : Object.create({});
        if (!delete_items || !delete_items.privateList) {
            delete_items.privateList = [];
        }
        delete_items.privateList.push(modal.id);
        this.setState({ privateList, delete_items });
        this.handleSubmit();
    };
    handlePropertyChange = (e: any, index: number) => {
        const privateList: PropertyOwnerItem[] = this.state.privateList;
        privateList.forEach((itm: any, i) => {
            if (i === index) {
                itm[e.target.name] = e.target.value;
            }
        });
        this.setState({ privateList });
        this.handleSubmit();
    };
    handleChange = (e, propName?, fieldType?) => {
        let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
        let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;
        if (fieldName === "lawhands_branch") {
            const branch = fieldValue;
            // const filteredBranches = this.state.branches.filter(
            //   branch => branch.bank_id === branch
            // );
            this.setState(
                {
                    lawhands_branch: fieldValue,
                    bank_name: "",
                    filteredProduct: [],
                    filteredBranches: [],
                    selected_product_id: "",
                    branch: "",
                    product_id: ""
                },
                () => {
                    // Directly pass the updated state to navigateToDocs
                    this.props.navigateToDocs({
                        ...this.state, // or you can manually pass the updated values if needed
                        filteredProduct: [],
                        filteredBranches: [],
                        selected_product_id: "",
                        branch: "",
                        product_id: ""
                    });
                }
            );
            const state = this.state;
            state[fieldName] = fieldValue;
            // this.setState({ filteredBranches });
        }
        if (fieldName === "product_id") {
            this.setState(
                {
                    filteredBranches: [],
                    branch: ""
                }, () => {
                    // Directly pass the updated state to navigateToDocs
                    this.props.navigateToDocs({
                        ...this.state, // or you can manually pass the updated values if needed
                        filteredBranches: [],
                        branch: ""
                    });
                    setTimeout(() => {
                        // Ensure the updated state is used inside these methods if needed
                        this.filterBranchesproduct(fieldValue);
                    }, 1000);
                }
            )
            let newProductId = e.product_id;
            const state = this.state;
            state.selected_product_id = newProductId;
        }
        if (fieldName === "bank_name") {
            this.setState(
                {
                    bank_name: fieldValue,
                    filteredProduct: [],
                    filteredBranches: [],
                    selected_product_id: "",
                    branch: "",
                    product_id: ""
                },
                () => {
                    // Directly pass the updated state to navigateToDocs
                    this.props.navigateToDocs({
                        ...this.state, // or you can manually pass the updated values if needed
                        filteredProduct: [],
                        filteredBranches: [],
                        selected_product_id: "",
                        branch: "",
                        product_id: ""
                    });
                    setTimeout(() => {
                        // Ensure the updated state is used inside these methods if needed
                        this.filterBranches(fieldValue);
                        this.filterProduct(fieldValue);
                    }, 1000);
                }
            );

        }
        if (fieldName === "branch") {
            if (this.state.branch != fieldValue) {
                this.getBros(fieldValue);
            }
            this.setState({ [fieldName]: fieldValue });
        }
        if (fieldName === "contact_number") {
            const isValidInput = /^[0-9/-]*$/.test(fieldValue);

            if (!isValidInput) {
                // Display an error message or handle the invalid input as needed
                console.error("Invalid input. Please enter only numeric characters, slash, or hyphen.");
                return;
            } else {
                if (fieldValue.length <= 10) {
                    this.setState({ [fieldName]: fieldValue });
                }
            }
        }
        if (fieldName === "loan_amount") {
            const inputValue = fieldValue;

            if (/^[ -]/.test(inputValue)) {
                console.error("Invalid input. The first letter cannot be a space or hyphen.");
                return;
            }
            this.setState({ [fieldName]: inputValue });
        }
        if (fieldName === "userHintAboutFile") {
            this.setState({ [fieldName]: fieldValue });
        }

        if (fieldName != "product_id" || fieldName != "contact_number") {
            const state = this.state;
            state[fieldName] = fieldValue;
            this.setState({ ...state });
        }
        // this.handleSubmit();
        const state = this.state;
        this.props.navigateToDocs(state);
    };
    handleSubmit = () => {
        const state = this.state;
        this.props.navigateToDocs(state);
    };
    saveHint = (event) => {
        event.preventDefault(); // Prevent the default form submission behavior

        const user = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        let req = {
            id: this.state.file_idfk,
            userid: userId,
            hints: this.state.userHintAboutFile
        }
        callApi('POST', 'add_hints.php', req)
            .then(res => res.data)
            .then(result => {
                // Handle the response here
                ToastsStore.success("Hint Saved");
            })
            .catch(err => {
                console.log(err);
            });
    }
    render() {
        console.log("Render", this.state);
        
        const filteredProduct = [
            { value: "", label: "" },
            ...this.state.filteredProduct
        ];
        return (
            <>
                <div className="row">
                    {/* <ToastsContainer
                        store={ToastsStore}
                        position={ToastsContainerPosition.TOP_CENTER}
                    /> */}
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Lawhands Branch<span style={{ color: "red" }}>*</span></label>
                            {this.state.lawhandsBranches && this.state.lawhandsBranches.length > 0 && this.state.lawhandsBranches.map((opt: any) => {
                                opt.label = opt.name; opt.value = opt.id
                            }) &&
                                <Select options={this.state.lawhandsBranches} name="lawhands_branch" className={this.props.required && this.state.lawhands_branch === '' ? 'form-select is-invalid' : 'form-select'}
                                    value={this.state.lawhandsBranches.find((o: any) => o.value === this.state.lawhands_branch)}
                                    onChange={(e) => this.handleChange(e, 'lawhands_branch', 'singleselect')}
                                />
                            }
                            <div className="invalid-feedback">*Required Field</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Bank Name<span style={{ color: "red" }}>*</span></label>
                            {this.state.banks && this.state.banks.length > 0 && this.state.banks.map((opt: any) => {
                                opt.label = opt.name; opt.value = opt.id
                            }) &&
                                <Select options={this.state.lawhands_branch ? this.state.banks : []} name="bank_name" className={this.props.required && this.state.bank_name === '' ? 'form-select is-invalid' : 'form-select'}
                                    value={this.state.banks.find((o: any) => o.value === this.state.bank_name)}
                                    onChange={(e) => this.handleChange(e, 'bank_name', 'singleselect')}
                                />
                            }
                            <div className="invalid-feedback">*Required Field</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Product<span style={{ color: "red" }}>*</span></label>
                            {this.state.products && this.state.products.map((opt: any) => {
                                opt.label = opt.product_name; opt.value = opt.id
                            }) &&
                                <Select options={filteredProduct ?? []} name="product_id" className={this.props.required && this.state.product_id === '' ? 'form-select is-invalid' : 'form-select'}
                                    value={this.state.filteredProduct.find((o: any) => o.product_id === this.state.selected_product_id ? this.state.selected_product_id : "")}
                                    onChange={(e) => this.handleChange(e, 'product_id', 'singleselect')}
                                />
                            }
                            <div className="invalid-feedback">*Required Field</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Bank Branch<span style={{ color: "red" }}>*</span></label>
                                </div>
                            </div>

                            {this.state.filteredBranches && this.state.filteredBranches.length > 0 && this.state.filteredBranches.map((opt: any) => {
                                opt.label = opt.name; opt.value = opt.id
                            }) &&
                                <Select options={this.state.filteredBranches ?? []} name="branch" className={this.props.required && this.state.branch === '' ? 'form-select is-invalid' : 'form-select'}
                                    value={this.state.filteredBranches && this.state.filteredBranches.find((o: any) => o.value === this.state.branch)}
                                    onChange={(e) => this.handleChange(e, 'branch', 'singleselect')}
                                />
                            }
                            {this.state.branch == "" && this.state.required == true && <div className="pt-1" style={{ fontSize: "11px", color: "#dc3545" }}>*Required Field</div>}
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-12">
                                    <label>Borrower Name / Applicant<span style={{ color: "red" }}>*</span><span className="inputEgMsg">Eg. Mr.Vijayakumar / Smt.Subbulakshmi / Miss.Devi / Jayasri Traders</span></label>
                                </div>
                            </div>
                            <input
                                className={this.props.required && this.state.borrower_name === '' ? 'form-control is-invalid' : 'form-control'}
                                placeholder="Ex - Chennai Silks / Mr. Ramasamy"
                                name="borrower_name"
                                type="text"
                                value={this.state.borrower_name}
                                onChange={e => {
                                    const event = { ...e }; // Clone the event to preserve it
                                    const value = e.target.value.toLowerCase(); // Convert everything to lowercase first
                                    const formattedValue = value.replace(/(^\w|(?<=\s|\/|\.)\w)/g, match => match.toUpperCase());
                                    this.setState({ borrower_name: formattedValue }, () => {
                                        this.handleChange(event);
                                    });
                                }}
                            />
                            <div className="invalid-feedback">*Required Field</div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-12">
                                    <label>Property Owner Name<span style={{ color: "red" }}>*</span><span className="inputEgMsg">Mr.Vijayakumar / Smt.Subbulakshmi / Miss.Devi / Miss.Devi</span></label>
                                </div>
                            </div>
                            <input
                                className={this.props.required && this.state.property_owner_name === '' ? 'form-control is-invalid' : 'form-control'}
                                placeholder="Ex - Mr.Vijayakumar"
                                name="property_owner_name"
                                type="text"
                                value={this.state.property_owner_name}
                                onChange={e => {
                                    const event = { ...e };
                                    const value = e.target.value.toLowerCase();
                                    const formattedValue = value.replace(/(^\w|(?<=\s|\/|\.)\w)/g, match => match.toUpperCase());
                                    this.setState({ property_owner_name: formattedValue }, () => {
                                        this.handleChange(event);
                                    });
                                }}
                            />
                            <div className="invalid-feedback">*Required Field</div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-12">
                                    <label>Co-Applicant<span className="inputEgMsg">Eg. Mr.Vijayakumar / Smt.Subbulakshmi / Miss.Devi / Jayasri Traders</span></label>
                                </div>
                            </div>
                            <input
                                className={'form-control'}
                                placeholder="Ex - Chennai Silks / Mr. Ramasamy"
                                name="coApplicant"
                                type="text"
                                value={this.state.coApplicant}
                                onChange={e => {
                                    const event = { ...e }; // Clone the event to preserve it
                                    const value = e.target.value.toLowerCase(); // Convert everything to lowercase first
                                    const formattedValue = value.replace(/(^\w|(?<=\s|\/|\.)\w)/g, match => match.toUpperCase());
                                    this.setState({ coApplicant: formattedValue }, () => {
                                        this.handleChange(event);
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-12">
                                    <label>App Id<span style={{ color: "red" }}>*</span><span className="inputEgMsg">If App ID Not Available / There is No App ID, Use 'NIL'</span></label>
                                </div>
                            </div>
                            <input
                                className={this.props.required && this.state.app_id === '' ? 'form-control is-invalid' : 'form-control'}
                                name="app_id"
                                placeholder="Example : Application No / LS No / Leaf ID / Proposal No"
                                type="text"
                                value={this.state.app_id}
                                onChange={e => this.handleChange(e)}
                            />
                            <div className="invalid-feedback">*Required Field</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>LH Branch Contact Number<span style={{ color: "red" }}>*</span></label>
                                </div>
                            </div>
                            <input
                                className={this.props.required && this.state.contact_number === '' ? 'form-control is-invalid' : 'form-control'}
                                placeholder="Ex - 9876543210"
                                name="contact_number"
                                type="text"
                                value={this.state.contact_number}
                                onChange={e => this.handleChange(e)}
                            />
                            <div className="invalid-feedback">*Required Field</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Loan Amount<span style={{ color: "red" }}>*</span></label>
                                </div>
                            </div>
                            <input
                                className={this.props.required && this.state.loan_amount === '' ? 'form-control is-invalid' : 'form-control'}
                                placeholder="Eg. Rs.6,00,000"
                                name="loan_amount"
                                type="text"
                                value={this.state.loan_amount}
                                onChange={e => this.handleChange(e)}
                            />
                            <div className="invalid-feedback">*Required Field</div>
                        </div>
                    </div>

                </div>
                <div className=" text-right">
                    <button
                        type="button"
                        className="btn btn-primary btn-sm "
                        onClick={() => this.addBro()}
                    >
                        Add BRO +
                    </button>
                </div>
                <div>
                    {this.state.brolist && this.state.brolist.length
                        ? this.state.brolist.map((broItem: BroItem, index: number) => (
                            <div className="row" key={index}>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label style={{ width: "300px" }}>
                                                    <a onClick={() => this.removeBro(broItem, index)}>
                                                        <i className="feather icon-trash deleteicon-trash" />
                                                    </a>
                                                    Branch / Credit / Sales - Manager Name
                                                </label>
                                            </div>
                                        </div>
                                        <input
                                            className="form-control"
                                            name="name"
                                            type="text"
                                            value={broItem.name}
                                            onChange={e => this.handleBroChange(e, index)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Designation</label>
                                            </div>
                                        </div>
                                        <input
                                            className="form-control"
                                            placeholder="Ex - Credit / Sales Managers"
                                            name="designation"
                                            type="text"
                                            value={broItem.designation}
                                            onChange={e => this.handleBroChange(e, index)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Mobile</label>
                                            </div>
                                        </div>
                                        <input
                                            className="form-control"
                                            name="mobile"
                                            type="number"
                                            maxLength={10}
                                            value={broItem.mobile}
                                            onChange={e => this.handleBroChange(e, index)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Email</label>
                                            </div>
                                        </div>
                                        <input
                                            className="form-control"
                                            name="email"
                                            type="email"
                                            value={broItem.email}
                                            onChange={e => this.handleBroChange(e, index)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                        : ""}
                </div>

                {/* {this.state.file_idfk != 0 && (
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Add Hints About File</label>
                                <textarea
                                    placeholder=""
                                    name="userHintAboutFile"
                                    value={this.state.userHintAboutFile}
                                    onChange={e => this.handleChange(e)}
                                    className="form-control"
                                    style={{ height: '10vh' }}
                                />
                            </div>
                        </div>
                        <button onClick={this.saveHint} type="button" className="btn btn-rounded btn-success" style={{ height: "40px", marginTop: "5%" }}>
                            Save
                        </button>
                    </div>
                )} */}
            </>
        );
    }
}
export default VettingLoginForm;
